export const getId = (id) => {
  return document.getElementById(id)
}